import React, { useState } from 'react';
import { billingApi } from '../services/api';

export const BillingActions: React.FC<{ subscribed: boolean }> = ({ subscribed }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const openBilling = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = subscribed ? await billingApi.createPortalSession() : await billingApi.createCheckoutSession();
      if (!result.url) throw new Error('Billing did not return a destination.');
      window.location.assign(result.url);
    } catch (err: any) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Billing is temporarily unavailable. Please try again or contact support.');
      setLoading(false);
    }
  };

  return <div>
    <button type="button" onClick={openBilling} disabled={loading} className="w-full rounded-xl bg-aspen-sage-teal px-6 py-3 font-semibold text-white transition hover:bg-aspen-deep-eucalyptus disabled:opacity-60">
      {loading ? 'Opening secure billing…' : subscribed ? 'Manage subscription' : 'Upgrade securely'}
    </button>
    {error && <p role="alert" className="mt-3 text-sm text-red-700 dark:text-red-300">{error}</p>}
  </div>;
};

export default BillingActions;
